import axios from 'axios';
import qs from 'query-string';
import { apiConfig } from '../api-config';
import { GetVoucherParams } from './get-all';

export const getAllVoucherInative = async (params: GetVoucherParams, cdUser: string, tokenKey: string, condition: string) => {
  const query = qs.stringify(params);
  const validateStatus = (status: number) => (status >= 200 && status <= 300) || status === 404;
  const getAllVoucher = apiConfig.get(`api/Voucher/getAll-by-status-inative?${query}`, { validateStatus });
  const getByCdUser = apiConfig.get(`api/ShareVoucher/get-by-cdUser?${query}`, { validateStatus });
  const totalVoucher = apiConfig.get(`api/Voucher/getAll-by-cdUser-all?tokenKey=${tokenKey}&cdUser=${cdUser}&condition=${condition}`);

  return axios.all([getAllVoucher, getByCdUser, totalVoucher]).then(axios.spread((res1, res3, res4) => ({
    vouchers: res1.data || [],
    size: res4.data,
    total: res3.data.expired || 0,
    avaliable: res3.data.expired,
    used: res3.data.used,
  }))).catch((err) => ({ hasErrors: true, err: err.message }));
};
